import React, { PropTypes, Component } from 'react';

import punycode from 'punycode';
import styles from './styles.scss';

export default class Counter extends Component {
  // static propTypes = {
  //   editorState: PropTypes.any,
  //   limit: PropTypes.number,
  // };

  getCharCount(data) {
    if (!data) {
      return 0;
    }
    const decodeUnicode = (str) => punycode.ucs2.decode(str); // func to handle unicode characters
    const plainText = data.replace(/<[^>]*>/g, '').replace(/\&nbsp\;/g, ' ');
    const regex = /(?:\r\n|\r|\n)/g; // new line, carriage return, line feed
    const cleanString = plainText.replace(regex, '').trim(); // replace above characters w/ nothing
    return decodeUnicode(cleanString).length;
  }

  render() {
    const { data, limit } = this.props;
    const count = this.getCharCount(data);
    // const classNames = this.getClassNames(count, limit);

    return (
      <div className={styles.counter}>
        {count} / {limit}
      </div>
    );
  }
}
